export default __webpack_public_path__ + "static/media/logo-nav.89575a5b.png";